import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import "./AdminPasswordProtection.css";

const ADMIN_PASSWORD = "admin123"; // Change this to your desired password

const AdminPasswordProtection = ({ children }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if admin password is already verified in this session
    const adminVerified = sessionStorage.getItem("adminPasswordVerified");
    if (adminVerified === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!password.trim()) {
      setError("Password is required");
      return;
    }

    if (password === ADMIN_PASSWORD) {
      // Store verification in sessionStorage (cleared when browser closes)
      sessionStorage.setItem("adminPasswordVerified", "true");
      setIsAuthenticated(true);
      setError("");
    } else {
      setError("Incorrect password. Access denied.");
      setPassword("");
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("adminPasswordVerified");
    setIsAuthenticated(false);
    setPassword("");
    navigate("/");
  };

  // If authenticated, show the admin panel
  if (isAuthenticated) {
    return (
      <>
        <div className="admin-password-header">
          <div className="admin-password-header-content">
            <span className="admin-lock-icon">
              <FaLock />
            </span>
            <span>Admin Panel - Protected</span>
            <button 
              className="admin-logout-btn" 
              onClick={handleLogout}
              title="Exit Admin Panel"
            >
              Exit Admin
            </button>
          </div>
        </div>
        {children}
      </>
    );
  }

  // Show password prompt
  return (
    <div className="admin-password-container">
      <div className="admin-password-modal">
        <div className="admin-password-header-icon">
          <FaLock />
        </div>
        <h2>Admin Panel Access</h2>
        <p className="admin-password-subtitle">
          This area is password protected. Please enter the admin password to continue.
        </p>
        
        <form onSubmit={handleSubmit} className="admin-password-form">
          <div className="admin-password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              placeholder="Enter admin password"
              className="admin-password-input"
              autoFocus
            />
            <button
              type="button"
              className="admin-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          
          {error && <div className="admin-password-error">{error}</div>}
          
          <button type="submit" className="admin-password-submit-btn">
            <FaLock /> Access Admin Panel
          </button>
        </form>

        <button 
          className="admin-password-cancel-btn"
          onClick={() => navigate("/")}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AdminPasswordProtection;
